import React from 'react';
import { connect } from 'react-redux';

import * as applyOffersActions from '../../../redux/applyOffers';
import './model-stats.scss';

interface Props {
  applyOffers: any;
  applicant: Attendee;
  setStatsToInches: Function;
}

interface State {
  applicant: Attendee;
  modelStats: ModelStatsData;
}

class ModelStats extends React.Component<Props, State> {
  state: State = { applicant: this.props.applicant, modelStats: this.props.applicant.model.stats };

  componentDidUpdate() {
    if (this.props.applicant.id !== this.state.applicant.id) {
      this.setState({
        applicant: this.props.applicant,
        modelStats: this.props.applicant.model.stats,
      });
    }
  }

  getStat(stat: string) {
    const inches = this.props.applyOffers.statsInInches;
    const stats = this.state.modelStats;

    if (stat === 'shoe') {
      const shoeMapping = this.props.applyOffers.shoeSizeMapping;
      const shoeMap = shoeMapping.find((element) => element.value === stats.shoe_size);
      return inches ? shoeMap.us_title : shoeMap.eu_title;
    }

    if (stat === 'waist') {
      const waistMapping = this.props.applyOffers.waistSizeMapping;
      const waistMap = waistMapping.find((element) => element.size === stats.waist_size);
      return inches ? waistMap.title : waistMap.title_eu;
    }

    if (stat === 'suit') {
      const suitMapping = this.props.applyOffers.suitSizeMapping;
      const suitMap = suitMapping.find((element) => element.size === stats.suit_size);
      return suitMap.title;
    }

    switch (stat) {
      case 'height':
        return inches ? `${stats.height?.feet}' ${stats.height?.inches}` : stats.height?.cm;
      case 'bust':
        return inches ? stats.bust_size?.inches : stats.bust_size?.cm;
      case 'shirt':
        return inches
          ? `${stats.collar_size?.inches}x${stats.sleeve_size?.inches}`
          : `${stats.collar_size?.cm}x${stats.sleeve_size?.cm}`;
      case 'inseam':
        return inches ? stats.inseam_size?.inches : stats.inseam_size?.cm;
      case 'hips':
        return inches ? stats.hips_size?.inches : stats.hips_size?.cm;
      default:
        return null;
    }
  }

  render() {
    const stats = this.state.modelStats;
    const model = this.state.applicant.model;

    return (
      <>
        <div className="model-stats">
          <div className="toggle">
            <button
              className={this.props.applyOffers.statsInInches ? 'active' : ''}
              onClick={() => this.props.setStatsToInches(true)}
            >
              in
            </button>
            /{' '}
            <button
              className={!this.props.applyOffers.statsInInches ? 'active' : ''}
              onClick={() => this.props.setStatsToInches(false)}
            >
              cm
            </button>
          </div>
          {stats.height ? (
            <div>
              <span className="stat">height</span>
              <span className="value">{this.getStat('height')}</span>
            </div>
          ) : null}
          {stats.bust_size && model.sex === 'f' ? (
            <div>
              <span className="stat">bust</span>
              <span className="value">{this.getStat('bust')}</span>
            </div>
          ) : null}
          {stats.collar_size && stats.sleeve_size && model.sex === 'm' ? (
            <div>
              <span className="stat">shirt</span>
              <span className="value">{this.getStat('shirt')}</span>
            </div>
          ) : null}
          {stats.suit_size && model.sex === 'm' ? (
            <div>
              <span className="stat">suit</span>
              <span className="value">{this.getStat('suit')}</span>
            </div>
          ) : null}
          {stats.inseam_size && model.sex === 'm' ? (
            <div>
              <span className="stat">inseam</span>
              <span className="value">{this.getStat('inseam')}</span>
            </div>
          ) : null}
          {stats.waist_size && model.sex === 'f' ? (
            <div>
              <span className="stat">waist</span>
              <span className="value">{this.getStat('waist')}</span>
            </div>
          ) : null}
          {stats.hips_size && model.sex === 'f' ? (
            <div>
              <span className="stat">hips</span>
              <span className="value">{this.getStat('hips')}</span>
            </div>
          ) : null}
          {stats.dress_size && model.sex === 'f' ? (
            <div>
              <span className="stat">dress</span>
              <span className="value">{stats.dress_size}</span>
            </div>
          ) : null}
          {stats.shoe_size ? (
            <div>
              <span className="stat">shoe</span>
              <span className="value">{this.getStat('shoe')}</span>
            </div>
          ) : null}
          {stats.hair_color ? (
            <div>
              <span className="stat">hair</span>
              <span className="value">{stats.hair_color}</span>
            </div>
          ) : null}
          {stats.eye_color ? (
            <div>
              <span className="stat">eyes</span>
              <span className="value">{stats.eye_color}</span>
            </div>
          ) : null}
        </div>
      </>
    );
  }
}

const mapStateToProps = ({ applyOffers }) => ({ applyOffers });

export default connect(mapStateToProps, applyOffersActions)(ModelStats);
